<template>
  <v-card flat rounded="lg">
    <v-card-title class="subtitle-1 font-weight-bold"
      >Dados de Contato</v-card-title
    >
    <v-card-text>
      <v-form ref="form">
        <v-row>
          <v-col xl="5" lg="5" md="5" cols="12">
            <v-card flat rounded="lg">              
              <v-card-text>
                <v-row>
                  <v-col xl="4" lg="4" md="4" cols="12" align-self="center">
                    <v-text-field
                      label="DDD"
                      v-mask="'##'"
                      v-model="clienteManut.dddcelular"
                    >
                    </v-text-field>
                  </v-col>

                  <v-col xl="8" lg="8" md="8" cols="12">
                    <v-text-field
                      label="Celular"
                      v-model="clienteManut.celular"
                      v-mask="'#########'"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col xl="3" lg="3" md="3" cols="12" align-self="center">
            <v-text-field
              label="Telefone"
              v-model="clienteManut.telefone"
              v-mask="'(##) ########'"
            ></v-text-field>
          </v-col>
          <v-col xl="4" lg="4" md="4" cols="12" align-self="center">
            <v-text-field
              label="E-mail"
              v-model="clienteManut.email"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapState } from "vuex";
export default {
  computed: mapState("clientes", ["clienteManut"]),
};
</script>

<style>
</style>